"use strict";
/**
 * @module Features
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var error_reason_1 = require("./../../errors/error-reason");
var jmx_fetch_request_1 = require("./../services/fetch-jmx-values/jmx-fetch-request");
var Services = require("./../services/metrics-services");
var measured_entity_class_request_1 = require("./../services/metrics/measured-entity-class-request");
var require_non_null_1 = require("./../util/require-non-null");
/**
 * Internal metrics feature.
 *
 * <p>Also provides access to JMX MBean values.
 */
var MetricsImpl = /** @class */ (function () {
    function MetricsImpl(internal) {
        this.internal = internal;
    }
    /**
     * Resolve and invoke a service.
     */
    MetricsImpl.prototype.callService = function (serviceDefinition, request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.internal.checkConnected(reject)) {
                var service = _this.internal.getServiceLocator().obtain(serviceDefinition);
                service.send(request, function (err, response) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        // tslint:disable-next-line:strict-type-predicates
                        resolve((response === null ? undefined : response));
                    }
                });
            }
        });
    };
    /**
     * Add a new session metric collector, removing any with the same name.
     */
    MetricsImpl.prototype.putSessionMetricCollector = function (sessionMetricCollector) {
        return __awaiter(this, void 0, void 0, function () {
            var errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        require_non_null_1.requireNonNull(sessionMetricCollector, 'sessionMetricCollector');
                        return [4 /*yield*/, this.callService(Services.PUT_SESSION_METRIC_COLLECTOR, sessionMetricCollector)];
                    case 1:
                        errors = _a.sent();
                        if (errors.errors.length !== 0) {
                            throw new Error("Invalid filter: " + errors.toString());
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove any session metric collector with the given name.
     */
    MetricsImpl.prototype.removeSessionMetricCollector = function (sessionMetricCollectorName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                require_non_null_1.requireNonNull(sessionMetricCollectorName, 'sessionMetricCollectorName');
                return [2 /*return*/, this.callService(Services.REMOVE_SESSION_METRIC_COLLECTOR, sessionMetricCollectorName)];
            });
        });
    };
    /**
     * Retrieve all session metric collectors.
     */
    MetricsImpl.prototype.listSessionMetricCollectors = function () {
        return this.callService(Services.LIST_SESSION_METRIC_COLLECTORS, null);
    };
    /**
     * Add a new topic metric collector, removing any with the same name.
     */
    MetricsImpl.prototype.putTopicMetricCollector = function (topicMetricCollector) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                require_non_null_1.requireNonNull(topicMetricCollector, 'topicMetricCollector');
                return [2 /*return*/, this.callService(Services.PUT_TOPIC_METRIC_COLLECTOR, topicMetricCollector)];
            });
        });
    };
    /**
     * Remove any topic metric collector with the given name.
     */
    MetricsImpl.prototype.removeTopicMetricCollector = function (topicMetricCollectorName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                require_non_null_1.requireNonNull(topicMetricCollectorName, 'topicMetricCollectorName');
                return [2 /*return*/, this.callService(Services.REMOVE_TOPIC_METRIC_COLLECTOR, topicMetricCollectorName)];
            });
        });
    };
    /**
     * Retrieve all topic metric collectors.
     */
    MetricsImpl.prototype.listTopicMetricCollectors = function () {
        return this.callService(Services.LIST_TOPIC_METRIC_COLLECTORS, null);
    };
    /**
     * Get the server-scope metrics.
     */
    MetricsImpl.prototype.getServerMetrics = function () {
        return this.callService(Services.GET_SERVER_METRICS, null);
    };
    /**
     * Get all metrics for a measured entity class. Optionally, a server can be specified.
     *
     * @param measuredEntityClassName e.g. "sessions", "topics"
     */
    MetricsImpl.prototype.getMeasuredEntityClassMetrics = function (entityClass, serverName) {
        return this.callService(Services.GET_MEASURED_ENTITY_CLASS_METRICS, new measured_entity_class_request_1.MeasuredEntityClassRequest(entityClass, serverName));
    };
    /**
     * Get connected server MBean values.
     *
     * @param JMX object names
     */
    MetricsImpl.prototype.fetchJMXValues = function (objectNames) {
        var resultMap = this.callService(Services.FETCH_JMX_VALUES, new jmx_fetch_request_1.JMXFetchRequest(objectNames, false));
        return resultMap.then(function (m) {
            var _a = __read(Object.keys(m)), first = _a[0], more = _a.slice(1);
            var firstResult = m[first];
            if (!more.length && !('reason' in firstResult)) {
                return firstResult;
            }
            throw error_reason_1.ErrorReason.INVALID_DATA;
        });
    };
    /**
     * Get map of server name(s) -> MBean values.
     *
     * @param JMX object names
     */
    MetricsImpl.prototype.fetchClusterJMXValues = function (objectNames) {
        return this.callService(Services.FETCH_JMX_VALUES, new jmx_fetch_request_1.JMXFetchRequest(objectNames, true));
    };
    return MetricsImpl;
}());
exports.MetricsImpl = MetricsImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/metrics.js
// module id = 1802
// module chunks = 1